require('../styles/tivoligroup.less')

function onScroll() {
  const div = document.querySelector('.header-logo-img')
  if (window.scrollY > 600) {
    div.parentElement.classList.add('header-minimal')
    div.style.width = `280px`
  } else {
    div.parentElement.classList.remove('header-minimal')
    div.style.width = `${100 - window.scrollY / 7}%`
  }
}

window.addEventListener('scroll', onScroll)

document.addEventListener('DOMContentLoaded', () => {
  onScroll()
})
